module.exports = __webpack_public_path__ + "static/media/NFT-Stock-Video.0139ac40.png";